import { PRODUCT_TYPE, type ProductDetail, SALE_STATUS } from '@/constants';
import { calculateMinProductPrice } from '@/features/gfProduct/utils';
import { formatCurrency } from '@/utils/formatters';
import styles from './ProductDetailHeader.module.scss';

// みんなのデザイン定型購入フローでは複数印刷面の場合にカラー・サイズ・印刷エリアが確定しているため確定価格を表示する。
// 通常フロー（コマ選択）や1面のみの場合は未確定なので基本価格＋印刷エリア追加料金の最安値を「〜」付きで表示する。
const resolveDisplayedPrice = (productDetail: ProductDetail, confirmedPrice: number | undefined): number => {
  if (confirmedPrice !== undefined) return confirmedPrice;
  if (productDetail.productType === PRODUCT_TYPE.template) return productDetail.basePrice;
  return calculateMinProductPrice(productDetail);
};

function ProductDetailHeader({
  productDetail,
  titleSuffix,
  templateTitle = false,
  confirmedPrice,
}: {
  productDetail: ProductDetail;
  /** 商品名の末尾に付加するテキスト（例: サイズ名） */
  titleSuffix?: string;
  /** true のとき商品名の代わりに定型文（「オリジナルグッズを仕上げよう」）を表示する */
  templateTitle?: boolean;
  /** 指定時はこの価格を確定価格として表示し「〜」を付けない。未指定時はアイテムの基本価格＋印刷エリア追加料金の最安値を「〜」付きで表示する */
  confirmedPrice?: number;
}) {
  const title = titleSuffix ? `${productDetail.name}${titleSuffix}` : productDetail.name;
  const isDiscontinued = productDetail.saleStatus === SALE_STATUS.discontinued;
  const displayedPrice = resolveDisplayedPrice(productDetail, confirmedPrice);
  const priceSuffix = confirmedPrice !== undefined ? '' : '〜';

  return (
    <>
      {templateTitle ? (
        <p className={styles.productTitle}>
          あなたの<span className={styles.templateTitleHighlight}>オリジナルグッズ</span>を仕上げよう
        </p>
      ) : (
        <p className={styles.productTitle}>{title}</p>
      )}
      <p className={styles.minProductPrice}>
        <span className={`${styles.priceText} ${isDiscontinued ? styles.priceTextDiscontinued : ''}`}>
          <span className={styles.minProductPriceCurrency}>¥</span>
          {formatCurrency(displayedPrice)}
          {priceSuffix} ＋送料
        </span>
        {isDiscontinued && <span className={styles.discontinuedLabel}>在庫切れ</span>}
      </p>
    </>
  );
}

export default ProductDetailHeader;
